import { createWebSocketStore } from 'src/components/#services/helpers';
import { api } from 'src/services/api/reallis';
export const getAvailableMintCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'accrual_getAvailableMintCount',
        agent: 'nft-retrodrop',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const accrualMint = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'accrual_mint',
        agent: 'nft-retrodrop',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
api.ws.ws1.auth.on('login', () => {
    getAvailableMintCount.send();
});
